import React from "react";
import { Link } from "react-router-dom";
import { Bookmark } from "lucide-react";
import DeskPanel from "./DeskPanel";
import { desk, fontMicro } from "./tokens";

const ContinueCard = ({ topic }) => (
  <Link
    to={`/topic/${topic.slug}`}
    className="group relative block border overflow-hidden transition-all hover:border-[#D92D20]"
    style={{ borderColor: desk.edge, backgroundColor: desk.surface }}
    data-testid={`continue-${topic.slug}`}
  >
    {/* tape strip thumbnail block */}
    <div
      className="h-20 relative overflow-hidden"
      style={{
        background: `repeating-linear-gradient(45deg,
          ${desk.surfaceHi} 0px ${desk.surfaceHi} 8px,
          ${desk.surface} 8px ${desk.surface} 16px)`,
      }}
    >
      <div
        className={`${fontMicro} absolute inset-0 flex items-center justify-center`}
        style={{ color: desk.inkMuted, letterSpacing: "0.4em" }}
      >
        // CLASSIFIED PREVIEW
      </div>
      {/* scanline */}
      <div
        aria-hidden
        className="absolute inset-0 pointer-events-none opacity-30"
        style={{
          background: "repeating-linear-gradient(0deg, rgba(255,255,255,0.04) 0px, transparent 1px, transparent 3px)",
        }}
      />
    </div>
    <div className="p-3">
      <div className={fontMicro} style={{ color: desk.inkMuted }}>
        {topic.category || "CASE FILE"}
      </div>
      <div
        className="font-display text-sm mt-1 line-clamp-2 group-hover:text-white"
        style={{ color: desk.ink }}
      >
        {topic.title}
      </div>
    </div>
  </Link>
);

const ContinueReading = ({ items = [] }) => (
  <DeskPanel title="CONTINUE READING" count={items.length} testid="desk-continue-reading">
    {items.length === 0 ? (
      <div
        className="border border-dashed p-6 text-center"
        style={{ borderColor: desk.edge, color: desk.inkMuted }}
      >
        <div className={fontMicro}>Nothing in progress — open any dossier and it&apos;ll appear here.</div>
      </div>
    ) : (
      <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
        {items.map((t) => <ContinueCard key={t.slug} topic={t} />)}
      </div>
    )}
  </DeskPanel>
);

export const Bookmarks = ({ items = [], onRemove }) => (
  <DeskPanel title="BOOKMARKS" count={items.length} testid="desk-bookmarks">
    {items.length === 0 ? (
      <div
        className="border border-dashed p-6 text-center"
        style={{ borderColor: desk.edge, color: desk.inkMuted }}
      >
        <div className={fontMicro}>No bookmarks. Pin a dossier to find it instantly.</div>
      </div>
    ) : (
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {items.map((t) => (
          <div
            key={t.slug}
            className="border p-3 flex items-start gap-3"
            style={{ borderColor: desk.edge, backgroundColor: desk.surface }}
            data-testid={`bookmark-${t.slug}`}
          >
            <Bookmark size={14} style={{ color: desk.gold }} className="mt-0.5 shrink-0" />
            <div className="flex-1 min-w-0">
              <div className={fontMicro} style={{ color: desk.inkMuted }}>
                {t.category || "CASE FILE"}
              </div>
              <Link
                to={`/topic/${t.slug}`}
                className="font-display text-sm hover:underline block truncate"
                style={{ color: desk.ink }}
              >
                {t.title || t.slug}
              </Link>
            </div>
            <button
              type="button"
              onClick={() => onRemove?.(t.slug)}
              className={`${fontMicro} border px-2 py-0.5 transition-colors hover:border-[#D92D20] hover:text-[#D92D20]`}
              style={{ borderColor: desk.edgeHi, color: desk.inkDim }}
              data-testid={`bookmark-remove-${t.slug}`}
            >
              REMOVE
            </button>
          </div>
        ))}
      </div>
    )}
  </DeskPanel>
);

export default ContinueReading;
